import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDELETE_privateNoteMutation, useGET_privateNotesQuery } from 'redux/api/privateNotesApi'
import PrivateNoteForm from 'components/organisms/forms/PrivateNoteForm'
import { ActionType, RoleType } from 'types'
import DialogPopup from 'components/molecules/DialogPopup'
import { Accordion, AccordionDetails, AccordionSummary, Button } from '@mui/material'
import { Delete, ExpandMore } from '@mui/icons-material'
import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { useSuccessAlert } from 'utils/customHooks/useSuccessAlert'

interface IProps {
  action: ActionType
  assignmentId?: string
  viewOnly: boolean
  userRole: RoleType
}

const slideProps = {
  mountOnEnter: true,
  unmountOnExit: true,
  timeout: { enter: 225, exit: 195 }
};

const PrivateNotes: FC<IProps> = ({ assignmentId }) => {
  const { t } = useTranslation()

  const [createPopupOpen, setCreatePopupOpen] = useState(false)

  const [
    deleteEntity,
    { isSuccess: deleteSuccess, error: deleteError },
  ] = useDELETE_privateNoteMutation()

  useErrorAlert(deleteError)
  useSuccessAlert(deleteSuccess ? t('alerts.entity-removed',{entity: t('common.private-note')}) : '')

  const { isLoading: isLoading, data: privateNotes } = useGET_privateNotesQuery({assignment_id: assignmentId})
  const data = privateNotes?.results ?? []


  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <Button
          variant='contained'
          color='success'
          onClick={() => {
            setCreatePopupOpen(true)
          }}
          sx={{ marginLeft: '5px' }}
        >
          {t('common.add-private-note')}
        </Button>
      </div>

      {data.map((note, index) => 
                          <Accordion 
                            TransitionProps={slideProps}
                            key={note.id} >
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                 {t('common.private-note')}: {note.title}
                            </AccordionSummary>
                            <AccordionDetails>  
                                <>
                                  <span dangerouslySetInnerHTML={{ __html: note.text }} />

                             
                                  <div style={{ marginTop: '20px' }}>
                                    <Button
                                      size='small'
                                      variant='contained'
                                      color='error'
                                      className='small-button'
                                      onClick={() => deleteEntity({assignment_id: assignmentId, id: note.id.toString()})}
                                    >
                                      <Delete />
                                      {`${t('common.delete')}`}
                                    </Button>
                                  </div>
                                </>   

                            </AccordionDetails>
                          </Accordion>  
                        ) 
        }   


      <DialogPopup
        title={t('common.add-private-note')}
        open={createPopupOpen}
        onClose={() => setCreatePopupOpen(false)}
        popupWidth={'1000px'}
      >
        <PrivateNoteForm 
          assignmentId={assignmentId}
          onCreate={() => {
            setCreatePopupOpen(false)
          }}
        />
      </DialogPopup>
    </>
  )
}

export default PrivateNotes
